import { cancelAnimationFrame, requestAnimationFrame } from '@folkjs/dom/rAF';
export class AnimationFrameController {
    #host;
    #lastTime;
    #dtAccumulator;
    #fixedTimestep;
    #timeoutMs;
    #timeoutId;
    get fixedTimestep() {
        return this.#fixedTimestep;
    }
    #isRunning;
    get isRunning() {
        return this.#isRunning;
    }
    constructor(host, timeoutMs = 5000) {
        this.#lastTime = 0;
        this.#dtAccumulator = 0;
        this.#fixedTimestep = 1 / 60;
        this.#timeoutId = -1;
        this.#isRunning = false;
        this.#tick = (timestamp = performance.now()) => {
            requestAnimationFrame(this.#tick);
            const actualDelta = (timestamp - this.#lastTime) * 0.001;
            this.#lastTime = timestamp;
            // Accumulate delta time, but clamp to avoid spiral of death
            this.#dtAccumulator = Math.min(this.#dtAccumulator + actualDelta, 0.2);
            while (this.#dtAccumulator >= this.#fixedTimestep) {
                this.#host.tick();
                this.#dtAccumulator -= this.#fixedTimestep;
            }
            this.#host.render();
        };
        this.stop = () => {
            cancelAnimationFrame(this.#tick);
            window.clearTimeout(this.#timeoutId);
            this.#isRunning = false;
        };
        this.#host = host;
        this.#timeoutMs = timeoutMs;
        host.addController(this);
    }
    hostConnected() {
        this.start();
    }
    hostUpdated() {
        this.reset();
    }
    hostDisconnected() {
        this.stop();
    }
    #tick;
    start() {
        if (this.isRunning)
            return;
        this.#lastTime = 0;
        this.#isRunning = true;
        this.#tick();
    }
    reset() {
        window.clearTimeout(this.#timeoutId);
        this.#timeoutId = window.setTimeout(this.stop, this.#timeoutMs);
        this.start();
    }
}
//# sourceMappingURL=animation-frame-controller.js.map